angular.module("vgresiduos").factory("mtrSystemService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";

		const _calculateMtrSystemsToIntegrate = function (dto) {
			const organizationId = accountService.getCurrentClient().organization.id;

			const req = {
				method: "post",
				data: dto,
				url:
					Vgr.constants.integrationsHostUrl +
					Vgr.resources.integrations.mtrSystems.replace("[ORGANIZATION]", organizationId) +
					"/integration-required"
			};
			return $http(req);
		};

		const _listMtrSystemLogins = function (dto) {
			const organizationId = accountService.getCurrentClient().organization.id;
			const req = {
				method: "post",
				data: dto,
				url:
					Vgr.constants.integrationsHostUrl +
					Vgr.resources.integrations.mtrSystemLogins.replace("[ORGANIZATION]", organizationId) +
					"/list"
			};
			return $http(req);
		};

		return {
			calculateMtrSystemsToIntegrate: _calculateMtrSystemsToIntegrate,

			listMtrSystemLogins: _listMtrSystemLogins
		};
	}
]);
